<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
        v-if="newCritereRecherche">
    <div class="column is-12 pdb-0" :class="[{ 'hauteur-haut-brief-filtre': errors.length === 0 },
    { 'hauteur-haut-brief-filtre-errors': errors.length > 0 }]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t(`${baseTraduction}.filtre.title`) }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t(`${baseTraduction}.filtre.sousTitle`) }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors" :error="hasError" :title="'general.problemOccurred'"
          :withEmplyFields="true" @close="closeErrorMsg" />
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
      :class="[{ 'hauteur-brief-filtre': errors.length === 0 },
    { 'hauteur-brief-filtre-errors': errors.length > 0 }]">
      <div class="column is-12 pdb-0">
        <qd-notification type="is-primary"
          v-if="intervenantEcheance" @close="deleteIds()" class="is-marginless pd-6px">
          <div>
            <span>
              {{ $t('listeFactureAchat.filtre.echeanceBail', {
                codeBail: codeBail,
              }) }}
            </span>
            <br />
            <span>
              {{ $t(`${baseTraduction}.filtre.echeanceTiers`, {
                tiers: intervenantEcheance,
              }) }}
            </span>
            <br />
            <span v-if="dateEcheance
              && dateEcheance.dateDebut && dateEcheance.dateFin">
              {{ $t('listeFactureAchat.filtre.echeancePeriode', {
                dateDebut: func.formatDate(dateEcheance.dateDebut),
                dateFin: func.formatDate(dateEcheance.dateFin),
              }) }}
            </span>
          </div>
        </qd-notification>
      </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <query-fournisseur-tag-input
          v-model="tiersSelected"
          :societeActiveId="societeActiveId"
          :label="$t(`${baseTraduction}.filtre.tiers`)"
          :sousType="tiersSousTypes"
          :disabled="isFromTiers">
        </query-fournisseur-tag-input>
      </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <libelle-tag-input :label="$t(`${baseTraduction}.filtre.etat`)"
          :items="constantes.FACTURE_ETAT"
          v-model="etatSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <input-periode
          v-model="newCritereRecherche.dates"
          :label="$t(`${baseTraduction}.filtre.periode`)">
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t(`${baseTraduction}.filtre.exporteeEnCompta`)">
          <b-select v-model="newCritereRecherche.exporteeEnCompta" expanded>
            <option :value=null></option>
            <option :value=true>
              {{ $t('listeFactures.filtre.exporteeEnComptaAnswer.yes') }}
            </option>
            <option :value=false>
              {{ $t('listeFactures.filtre.exporteeEnComptaAnswer.no') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input :label="$t(`${baseTraduction}.filtre.agence`)"
          :items="agencesSelectionnees"
          v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{ $t(`${baseTraduction}.filtre.actions.appliquer`) }}
      </button>

      <button @click="viderCritere()"
        class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t(`${baseTraduction}.filtre.actions.reinitialiser`) }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import { get } from '@/api/facture';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import formatDate from '@/services/general/formatDate';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import inputPeriode from '@/components/general/inputPeriode';
import queryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';

const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      errors: [],
      hasError: false,
      newCritereRecherche: null,
      constantes: {
        FACTURE_ETAT,
        TIERS_TYPE_FOURNISSEUR,
      },
      etatSelected: [],
      tiersSelected: [],
      isFetching: false,
      filteredTiers: [],
      func: {
        formatDate,
      },
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
    intervenantEcheance: {
      type: String,
      required: false,
    },
    dateEcheance: {
      type: Object,
      required: false,
    },
    codeBail: {
      type: String,
      required: false,
    },
    baseTraduction: {
      type: String,
      required: true,
    },
    tiersSousTypes: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    critereRechecheInit: {
      type: Object,
      required: true,
    },
    isFromTiers: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
    inputPeriode,
    queryFournisseurTagInput,
  },
  methods: {
    deleteIds() {
      this.newCritereRecherche.ids = [];
      this.newCritereRecherche.idsOrReferences = [];
      this.appliquerCritere();
    },
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    appliquerCritere() {
      const critereCopy = cloneDeep(this.newCritereRecherche);
      critereCopy.etat = this.etatSelected.map(el => { return el.code; });
      critereCopy.tiersId = this.tiersSelected;
      critereCopy.dates.dateDebut = formatIsoDate(
        critereCopy.dates.dateDebut,
      );
      critereCopy.dates.dateFin = formatIsoDate(
        critereCopy.dates.dateFin,
      );
      this.$emit('recherche', critereCopy);
    },
    viderCritere() {
      this.newCritereRecherche = {
        ...this.critereRechecheInit,
        idsOrReferences: this.newCritereRecherche.idsOrReferences,
      };
      this.etatSelected = [];
      this.tiersSelected = this.critereRechecheInit.tiersId?.length > 0
        ? this.critereRechecheInit.tiersId : [];
    },
    initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const newCritereRecherche = cloneDeep(this.critereRecherche);

        if (newCritereRecherche.dates.dateDebut) {
          newCritereRecherche.dates.dateDebut = moment(newCritereRecherche.dates.dateDebut)
            .toDate();
        }
        if (newCritereRecherche.dates.dateFin) {
          newCritereRecherche.dates.dateFin = moment(newCritereRecherche.dates.dateFin)
            .toDate();
        }

        if (newCritereRecherche.ids) {
          const promiseFacture = [];
          newCritereRecherche.ids.forEach((factureId) => {
            promiseFacture.push(get(factureId));
          });
        }

        this.newCritereRecherche = newCritereRecherche;

        this.tiersSelected = this.newCritereRecherche.tiersId;

        if (this.newCritereRecherche.etat) {
          this.etatSelected = this.constantes.FACTURE_ETAT.filter((c) => {
            return this.newCritereRecherche.etat.includes(c.code);
          });
        }

        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped></style>
